import type { QueryClient } from '@tanstack/react-query';

/**
 * Drops every cached list whose contents depend on the Artisan profile ↔ work order link.
 *
 * Linking and unlinking each change two features at once. The Artisan Sync list carries
 * `is_synced`, the linked work order number, and whether the row may be selected for
 * deletion; the work order lists carry `use_roast_profile`, which is what decides whether a
 * work order is still offered as a sync target. Either side changing invalidates both.
 *
 * This has to be called explicitly because the Artisan Sync list is cached with a five
 * minute staleTime (useArtisanSyncPage.ts). React Query does not refetch a query it still
 * considers fresh, so switching back to that tab inside the window renders the cache. A
 * caller that skips this leaves the other tab showing the pre-change state (AS-005).
 *
 * The prefix key covers the paginated/filtered list and the per-profile detail query alike.
 */
export function invalidateArtisanLinkQueries(queryClient: QueryClient): void {
  queryClient.invalidateQueries({ queryKey: ['artisan-profiles'] });
  queryClient.invalidateQueries({ queryKey: ['work-orders'] });
}
